import {
  ConversationStatsResponse,
  GetConversationMessagesResponse,
  GetPaginatedConversationsRequest,
  GetPaginatedConversationsResponse,
  ResolvedSuggestionsResponse,
  UpdateConversationRequest,
} from "@financial-advisory/data-access/api-types";
import { orchestrationApi } from "./orchestrationApi";

export const conversationsApi = orchestrationApi.injectEndpoints({
  endpoints: (builder) => ({
    getConversationStats: builder.query<ConversationStatsResponse, void>({
      query: () => `/conversations/stats`,
    }),
    getPaginatedConversations: builder.query<
      GetPaginatedConversationsResponse,
      GetPaginatedConversationsRequest
    >({
      query: (params) => {
        const searchParams = new URLSearchParams();
        if (params.page != null) searchParams.set("page", String(params.page));
        if (params.size != null) searchParams.set("size", String(params.size));
        if (params.search) searchParams.set("search", params.search);
        return `/conversations?${searchParams.toString()}`;
      },
    }),
    updateConversation: builder.mutation<void, UpdateConversationRequest>({
      query: ({ session_id, feedback }) => ({
        url: `/conversations/${session_id}/feedback`,
        method: "PUT",
        body: { feedback },
      }),
    }),
    getConversationMessages: builder.query<
      GetConversationMessagesResponse,
      string
    >({
      query: (sessionId) => `/conversations/${sessionId}/messages`,
    }),
    getResolvedSuggestions: builder.query<
      ResolvedSuggestionsResponse,
      string
    >({
      query: (sessionId) => `/conversations/${sessionId}/resolved_suggestions`,
    }),
  }),
});

export const {
  useGetConversationStatsQuery,
  useGetPaginatedConversationsQuery,
  useGetConversationMessagesQuery,
  useLazyGetConversationMessagesQuery,
  useLazyGetResolvedSuggestionsQuery,
  useUpdateConversationMutation,
} = conversationsApi;
